import { AxiosRequestConfig } from 'axios';
import { BaseApi } from './base-api.service';
import URL from '../../constants/api-constants';
import { generatePath } from 'react-router-dom';

export class CycleOperationsService {
  private static readonly apiService = new BaseApi();

  static async startCycle(cycleId: string, options?: { skipCalCertCheck?: boolean }): Promise<void> {
    const headers: AxiosRequestConfig['headers'] = this.apiService.getApiVersionHeader();

    const path = generatePath(URL.CYCLE_START, { id: cycleId });
    await this.apiService.api.post(path, { skipCalCertCheck: options?.skipCalCertCheck }, { headers });
  }

  static async stopCycle(cycleId: string): Promise<void> {
    const headers: AxiosRequestConfig['headers'] = this.apiService.getApiVersionHeader();

    const path = generatePath(URL.CYCLE_STOP, { id: cycleId });
    await this.apiService.api.post(path, '', { headers });
  }

  static async pauseCycle(cycleId: string): Promise<void> {
    const headers: AxiosRequestConfig['headers'] = this.apiService.getApiVersionHeader();

    const path = generatePath(URL.CYCLE_PAUSE, { id: cycleId });
    await this.apiService.api.post(path, '', { headers });
  }

  static async unpauseCycle(cycleId: string): Promise<void> {
    const headers: AxiosRequestConfig['headers'] = this.apiService.getApiVersionHeader();

    const path = generatePath(URL.CYCLE_UNPAUSE, { id: cycleId });
    await this.apiService.api.post(path, '', { headers });
  }

}
